/** HubSpot's object type ID for contacts. */
export const HUBSPOT_CONTACT_OBJECT_TYPE = '0-1';

const NUMERIC_ID = /^\d+$/;

/**
 * Build a direct HubSpot contact-record URL without depending on a web or
 * native runtime. Portal and record IDs are intentionally validated here so
 * every client uses the same URL shape and rejects malformed configuration.
 */
export function buildHubSpotContactRecordUrl(
  portalId: string | null | undefined,
  contactId: string | null | undefined,
): string | null {
  const portal = portalId?.trim();
  const contact = contactId?.trim();
  if (!portal || !contact || !NUMERIC_ID.test(portal) || !NUMERIC_ID.test(contact)) {
    return null;
  }

  return `https://app.hubspot.com/contacts/${portal}/record/${HUBSPOT_CONTACT_OBJECT_TYPE}/${contact}`;
}
